"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterNullableBooleanCell = void 0;
const common_types_1 = require("../../../common-types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const select_1 = require("../../../components/select/select");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const list_source_hook_1 = require("../../../utils/list-source-hook");
function FilterNullableBooleanCell({ disabled, value, state, onChangeState, }) {
    const intl = (0, react_intl_1.useIntl)();
    const handleChange = (0, event_callback_hook_1.useEventCallback)((value) => {
        if (value === 'true') {
            onChangeState({
                ...state,
                operation: common_types_1.ApiFilterOperation.NOT_NULL,
                value: value,
            });
        }
        else {
            onChangeState({
                ...state,
                operation: common_types_1.ApiFilterOperation.IS_NULL,
                value: value,
            });
        }
    });
    return (react_1.default.createElement(select_1.Select, { disabled: disabled, source: (0, list_source_hook_1.useStaticListSource)([
            {
                id: 'true',
                name: intl.formatMessage({
                    id: 'EAS_TABLE_FILTER_CELL_BOOLEAN_OPTION_SELECTED',
                    defaultMessage: 'Vybrané',
                }),
            },
            {
                id: 'false',
                name: intl.formatMessage({
                    id: 'EAS_TABLE_FILTER_CELL_BOOLEAN_OPTION_NOT_SELECTED',
                    defaultMessage: 'Nevybrané',
                }),
            },
        ]), value: value, onChange: handleChange, valueIsId: true }));
}
exports.FilterNullableBooleanCell = FilterNullableBooleanCell;
//# sourceMappingURL=filter-nullable-boolean-cell.js.map